import {AxiosInstance} from "axios";
import DictionaryItem from "../model/dictionary/DictionaryItem";
import JobType from "../model/job/JobType";


/**
 * Api for job type.
 */
export default class JobTypeApi {
	constructor(public readonly axiosInstance: AxiosInstance) { }

	/**
	 * Fetch job types.
	 * @returns {Promise<DictionaryItem[]>} Promise containing all job types.
	 */
	fetchJobTypes(): Promise<JobType[]> {
		const url = `/api/web/jobs/jobs_types`;
		return this.axiosInstance.get(url).then(resp => resp.data.map(JobType.fromJson));
	}

	/**
	 * Update job type action.
	 */
	updateJobType(jobTypeId: string, data: JobType): Promise<JobType> {
		const url = `/api/web/jobs/jobs_types/${jobTypeId}`;
		return this.axiosInstance.put(url, data.toJson()).then(resp => JobType.fromJson(resp.data));
	}

}